import React from "react";
import { Link } from "react-router-dom";
import { Youtube, Facebook, Instagram, MessageCircle, Mail, Phone } from "lucide-react";
import { MINISTRY } from "@/data/site";
import GoldCross from "@/components/GoldCross";

const socials = [
  { name: "YouTube", icon: Youtube, url: "https://www.youtube.com/@orphôss" },
  { name: "Facebook", icon: Facebook, url: "https://www.facebook.com/steevehorphoss" },
  { name: "Instagram", icon: Instagram, url: "https://www.instagram.com/steeveorphosss/" },
  { name: "WhatsApp", icon: MessageCircle, url: "https://wa.me/33758798906" },
];

const navCol = [
  { label: "Accueil", to: "/" },
  { label: "À propos", to: "/a-propos" },
  { label: "Vidéos", to: "/videos" },
  { label: "Boutique", to: "/boutique" },
  { label: "Contact", to: "/contact" },
  { label: "Faire un don", to: "/faire-un-don" },
];

const resources = [
  "Enseignements",
  "Messages prophétiques",
  "Louange et adoration",
  "Témoignages",
  "Livres et e-books",
  "Packs spirituels",
];

export const Footer = () => {
  return (
    <footer className="relative bg-brown-dark text-ivory overflow-hidden" data-testid="main-footer">
      <GoldCross className="absolute right-0 top-0 h-full w-64" opacity={0.05} />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <div className="flex items-center justify-center w-11 h-11 rounded-full border border-gold/40">
                <svg viewBox="0 0 24 34" className="w-4 h-6">
                  <rect x="9.5" y="0" width="5" height="34" rx="1.2" fill="#E6C76A" />
                  <rect x="2" y="8" width="20" height="5" rx="1.2" fill="#E6C76A" />
                </svg>
              </div>
              <p className="font-heading text-lg font-semibold tracking-wide text-gold-light">
                PROPHÈTE STEEVE ORPHÔSS
              </p>
            </div>
            <p className="text-ivory/70 text-sm leading-relaxed max-w-xs">{MINISTRY.tagline}</p>
            <div className="flex items-center gap-2 mt-6">
              {socials.map((s) => (
                <a
                  key={s.name}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.name}
                  data-testid={`footer-social-${s.name.toLowerCase()}`}
                  className="p-2.5 rounded-full border border-gold/30 text-ivory/70 hover:text-brown-dark hover:bg-gold-light hover:border-gold-light transition-all duration-300"
                >
                  <s.icon size={16} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-gold-light text-sm uppercase tracking-[0.2em] mb-5 font-body font-semibold">Navigation</h4>
            <ul className="space-y-3">
              {navCol.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-ivory/70 text-sm hover:text-gold-light transition-colors duration-300">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-gold-light text-sm uppercase tracking-[0.2em] mb-5 font-body font-semibold">Ressources</h4>
            <ul className="space-y-3">
              {resources.map((r) => (
                <li key={r}>
                  <Link to="/boutique" className="text-ivory/70 text-sm hover:text-gold-light transition-colors duration-300">
                    {r}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-gold-light text-sm uppercase tracking-[0.2em] mb-5 font-body font-semibold">Contact</h4>
            <ul className="space-y-4 text-sm text-ivory/70">
              <li className="flex items-center gap-3">
                <Mail size={16} className="text-gold" />
                <Link to="/contact#contact-form" className="hover:text-gold-light transition-colors">{MINISTRY.email}</Link>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={16} className="text-gold" />
                <span>{MINISTRY.phone}</span>
              </li>
              <li className="flex items-center gap-3">
                <MessageCircle size={16} className="text-gold" />
                <a href={`https://wa.me/${MINISTRY.whatsappFr}`} target="_blank" rel="noopener noreferrer" className="hover:text-gold-light transition-colors">WhatsApp France</a>
              </li>
              <li className="flex items-center gap-3">
                <MessageCircle size={16} className="text-gold" />
                <a href={`https://wa.me/${MINISTRY.whatsappCi}`} target="_blank" rel="noopener noreferrer" className="hover:text-gold-light transition-colors">WhatsApp Côte d'Ivoire</a>
              </li>
              <li className="flex items-center gap-3">
                <Youtube size={16} className="text-gold" />
                <a href={MINISTRY.youtubeUrl} target="_blank" rel="noopener noreferrer" className="hover:text-gold-light transition-colors">YouTube</a>
              </li>
              <li className="flex items-center gap-3">
                <Facebook size={16} className="text-gold" />
                <a href={MINISTRY.facebookUrl} target="_blank" rel="noopener noreferrer" className="hover:text-gold-light transition-colors">Facebook</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="gold-line my-10 opacity-40" />

        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-ivory/55">
          <p>© 2026 Prophète Steeve Orphôss — Tous droits réservés.</p>
          <p className="font-heading italic text-sm text-gold-light/80">Conçu avec foi, excellence et passion.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
